var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(_vm.$store.state.app.currentCurrency==='THB')?_c('span',[_vm._v("฿")]):(_vm.$store.state.app.currentCurrency==='USD')?_c('span',[_vm._v("$")]):_c('span',[_vm._v("₩")])])}
var staticRenderFns = []

export { render, staticRenderFns }